import type { ProductListResponse } from '@frontend/features/product-list/libs/type'

import { endpoint } from '@shared/services/endpoint'
import useSWR from 'swr'

import type { Pagination, ResponseFailed } from '../types/common'
import type {
  Product,
  ProductDetails,
  ProductMetaAttributes,
  ProductMetaTerm,
  Sort,
} from '../types/product'

import { getRequest } from '../../../shared/services/fetcher'
import { createURLParams } from '../utils'

export type GetProductRequest = {
  brand?: string
  categories?: string
  color?: string
  limit?: number
  page?: number
  size?: string
  sort?: Sort
}

type ResponseSuccess<T> = {
  data: T
  message?: string
  meta?: {
    attributes?: ProductMetaAttributes
    pagination?: Pagination
    term?: ProductMetaTerm
  }
  success: true
}

type Response<T> = ResponseFailed | ResponseSuccess<T>

export type GetProductResponse = Response<Product[]>
export type GetProductBySlugResponse = Response<ProductDetails>

export function useProduct() {
  const useGetProduct = (request: GetProductRequest) => {
    const params = createURLParams(request)
    return useSWR<ProductListResponse, Error, string>(
      `${endpoint.frontend.PRODUCTS}?${params}`,
      getRequest,
    )
  }

  const useGetBySlug = (slug: string) => {
    return useSWR<ProductDetails, unknown, string>(
      `${endpoint.frontend.PRODUCTS}/${slug}`,
      getRequest,
    )
  }

  return { getBySlug: useGetBySlug, getProduct: useGetProduct }
}

export default useProduct
